import React from 'react';
import { ElementNode /*, Sentence*/ } from '@tikka/client/client-aliases';
import { StoryTree } from './story-tree';

export const SentencePresentation = ({ node }: { node: ElementNode }) => {
  // const element = node.element as Sentence;
  return <StoryTree node={node} />; // the words
};
